import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import useConfig from '../../hooks/useConfig';
var cls = 'text-box';

var TextBox = function TextBox(_ref) {
  var className = _ref.className,
      config = _ref.config,
      id = _ref.id,
      pid = _ref.pid;
  var textColor = config.textColor,
      fontSize = config.fontSize,
      lineHeight = config.lineHeight,
      textAlign = config.textAlign,
      fontWeight = config.fontWeight,
      text = config.text;

  var _useConfig = useConfig(),
      createNamespace = _useConfig.createNamespace,
      prefixCls = _useConfig.prefixCls;

  var classes = classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls, prefixCls), className);
  return _jsx("div", Object.assign({
    "data-componentid": id,
    "data-pid": pid,
    className: classes,
    style: {
      color: textColor,
      fontSize: fontSize && fontSize + 'px',
      lineHeight: lineHeight && lineHeight + 'px',
      textAlign: textAlign,
      fontWeight: fontWeight
    }
  }, {
    children: text
  }));
};

TextBox.defaultProps = {
  config: {}
};
TextBox.displayName = 'TextBox';
export default TextBox;